import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import ListAndTagDropdown from '../shared/ListAndTagDropdown';
import { api } from '../../config/api';

const MoveWordsModal = ({ isOpen, onClose, wordIds, currentListId, onReload }) => {
  const [selectedList, setSelectedList] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setSelectedList('');
  }, [isOpen]);

  const handleMove = async () => {
    if (!selectedList) {
      setError('Wybierz listę docelową');
      return;
    }

    setIsLoading(true);
    try {
      await api.moveWords(wordIds, selectedList);
      onClose(true);
      setSelectedList('');
      onReload();
    } catch (err) {
      setError(err.message || 'Wystąpił błąd podczas przenoszenia słówek');
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
    >
      <motion.div
        initial={{ scale: 0.95, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.95, opacity: 0 }}
        className="bg-white rounded-lg p-6 w-full max-w-md"
      >
        <h2 className="text-xl font-semibold mb-4">Przenieś słówka</h2>
        
        <div className="mb-4">
          <p className="text-sm text-neutral-600 mb-2">
            Wybierz listę, do której chcesz przenieść słówka:
          </p>
          <ListAndTagDropdown
            selectedList={selectedList}
            onListChange={setSelectedList}
            onlyList={true}
            excludeList={currentListId}
          />
        </div>

        {error && (
          <p className="text-sm text-red-500 mb-4">{error}</p>
        )}

        <div className="flex justify-end gap-2">
          <button
            onClick={() => onClose(false)}
            className="px-4 py-2 text-sm font-medium text-neutral-600 bg-neutral-100 rounded-md hover:bg-neutral-200 transition-colors"
          >
            Anuluj
          </button>
          <button
            onClick={handleMove}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 transition-colors disabled:opacity-50"
          >
            {isLoading ? 'Przenoszenie...' : 'Przenieś'}
          </button>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default MoveWordsModal; 